import PrimaryTap from '@/ui/taps/primary/regular/PrimaryTap';
import { Container } from './PrimaryMenuStyles';
import { forwardRef } from 'react';

interface PrimaryMenuProps {
  menuList?: any[];
  activeIndex?: number;
  margin?: any;
  onClick?: (index: number) => void;
  mode?: string;
  itemMaxWidth?: any;
  sx?: any;
}

const PrimaryMenu = forwardRef(
  (
    {
      menuList = [],
      activeIndex = 0,
      margin,
      onClick,
      mode = 'slider',
      itemMaxWidth,
      sx,
    }: PrimaryMenuProps,
    ref,
  ) => {
    const handleClick = (index) => onClick(index);

    return (
      <Container mode={mode} style={{ ...sx }} ref={ref}>
        {menuList.map((menu, i) => (
          <PrimaryTap
            isActive={i === activeIndex}
            maxWidth={itemMaxWidth}
            key={i}
            margin={margin}
            onClick={() => handleClick(i)}
          >
            {menu}
          </PrimaryTap>
        ))}
      </Container>
    );
  },
);

export default PrimaryMenu;
